/* DropCoffee — dc-fx (12-oct-2026, prueba pedida por Nicolás; ideas del Framer Marketplace, código propio).
   Estilos en assets/dc-fx.css. Se carga con defer. Con "reducir movimiento" no hace nada
   (el muro de stickers queda como una pila quieta). Se revierte quitándolo de layout/theme.liquid. */
(function () {
  'use strict';
  var mq = function (q) { return !!(window.matchMedia && window.matchMedia(q).matches); };
  if (mq('(prefers-reduced-motion: reduce)') || (window.Shopify && window.Shopify.designMode)) return;
  var EASE = 'cubic-bezier(.2,.8,.2,1)';

  /* Solo se anima lo que está bajo el pliegue al cargar (lo visible queda quieto: también es el destino de las transiciones). */
  function belowFold(el) { return el.getBoundingClientRect().top > window.innerHeight; }
  function onEnter(els, fn, margin) {
    if (!('IntersectionObserver' in window) || !els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { io.unobserve(en.target); fn(en.target); } });
    }, { rootMargin: margin || '0px 0px -12% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 1. Decode: [origins], [drops], [the_club]… se resuelven desde caracteres pixel ---------- */
  var GLYPHS = '#/_[]01<>*+=%$';
  function decode(el) {
    var nodes = [];
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) { return n.nodeValue.trim() && !(n.parentElement && n.parentElement.closest('.dc-sym')) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT; }
    });
    while (walker.nextNode()) nodes.push(walker.currentNode);
    if (!nodes.length) return;
    var w = el.getBoundingClientRect().width;
    el.classList.add('dc-decode');
    el.style.minWidth = w + 'px';
    var spans = nodes.map(function (n) {
      var s = document.createElement('span');
      s.setAttribute('aria-hidden', 'true');
      n.parentNode.insertBefore(s, n);
      n.parentNode.removeChild(n);
      return { s: s, n: n, t: n.nodeValue };
    });
    var total = spans.reduce(function (a, x) { return a + x.t.length; }, 0);
    var frames = 16, f = 0, timer = 0;
    function tick() {
      f++;
      var idx = 0;
      spans.forEach(function (x) {
        var out = '';
        for (var i = 0; i < x.t.length; i++, idx++) {
          var c = x.t[i];
          var done = f >= 4 + Math.floor((idx / Math.max(1, total)) * (frames - 4));
          out += (done || c === ' ') ? c.replace(/&/g, '&amp;').replace(/</g, '&lt;') : '<span class="dc-decode__c">' + GLYPHS[(Math.random() * GLYPHS.length) | 0].replace('<', '&lt;') + '</span>';
        }
        x.s.innerHTML = out;
      });
      if (f >= frames) {
        clearInterval(timer);
        spans.forEach(function (x) { x.s.parentNode.insertBefore(x.n, x.s); x.s.parentNode.removeChild(x.s); });
        el.classList.remove('dc-decode');
        el.style.minWidth = '';
      }
    }
    tick(); /* primer cuadro al tiro: el título nunca queda vacío */
    timer = setInterval(tick, 42);
  }
  function initDecode() {
    onEnter([].slice.call(document.querySelectorAll('.dc-section .dc-h-md .dc-brk__w')).filter(belowFold), decode, '0px 0px -18% 0px');
  }

  /* ---------- 2. Frase final: se enciende palabra por palabra con el scroll ---------- */
  function initLit() {
    var p = document.querySelector('.dc-statement p');
    if (!p) return;
    var words = [];
    var walker = document.createTreeWalker(p, NodeFilter.SHOW_TEXT);
    var texts = [];
    while (walker.nextNode()) texts.push(walker.currentNode);
    texts.forEach(function (n) {
      var frag = document.createDocumentFragment();
      n.nodeValue.split(/(\s+)/).forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
        var s = document.createElement('span');
        s.className = 'dc-lit__w';
        s.textContent = part;
        frag.appendChild(s);
      });
      n.parentNode.replaceChild(frag, n);
    });
    words = [].slice.call(p.querySelectorAll('.dc-lit__w'));
    if (!words.length) return;
    p.classList.add('dc-lit');
    var ticking = false;
    function update() {
      ticking = false;
      var r = p.getBoundingClientRect(), vh = window.innerHeight;
      var prog = (vh * 0.88 - r.top) / (r.height + vh * 0.38);
      prog = Math.max(0, Math.min(1, prog));
      var on = Math.round(prog * words.length);
      words.forEach(function (w, i) { w.classList.toggle('is-on', i < on); });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ---------- 3. Odómetro en el total del combinador y en el precio de la ficha (sigue a la cantidad) ---------- */
  function initOdometer() {
    var els = document.querySelectorAll('.dc-combine [data-sum-total], .dc-price [data-price-total]');
    if (!els.length || !('MutationObserver' in window)) return;
    var STRIP = '<span>0</span><span>1</span><span>2</span><span>3</span><span>4</span><span>5</span><span>6</span><span>7</span><span>8</span><span>9</span>';
    [].forEach.call(els, function (el) {
      var prev = el.textContent.trim(); /* el precio de la ficha parte con número: rueda desde ahí */
      var mo = new MutationObserver(function () {
        if (el._dcOdo) return;
        var text = el.textContent;
        if (!text || text === prev || el.querySelector('.dc-odo')) return;
        render(text);
      });
      function render(text) {
        el._dcOdo = true;
        var chars = text.split('');
        var html = '<span class="dc-odo" aria-hidden="true">';
        var targets = [];
        chars.forEach(function (c, i) {
          if (/\d/.test(c)) {
            var fromRight = chars.length - 1 - i;
            var old = prev.charAt(prev.length - 1 - fromRight);
            var start = /\d/.test(old) ? +old : 0;
            html += '<span class="dc-odo__d"><span class="dc-odo__s" style="transition:none;transform:translateY(' + (-start * 10) + '%)">' + STRIP + '</span></span>';
            targets.push(+c);
          } else {
            html += '<span>' + c.replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</span>';
          }
        });
        /* Los lectores de pantalla leen el número entero, no las tiras de dígitos. */
        html += '</span><span class="visually-hidden">' + text.replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</span>';
        el.innerHTML = html;
        mo.takeRecords();
        prev = text;
        var strips = el.querySelectorAll('.dc-odo__s');
        el.offsetWidth; /* aplica la posición inicial antes de animar */
        [].forEach.call(strips, function (s, k) {
          s.style.transition = 'transform ' + (0.55 + k * 0.08) + 's ' + EASE;
          s.style.transform = 'translateY(' + (-targets[k] * 10) + '%)';
        });
        el._dcOdo = false;
      }
      mo.observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  /* ---------- 4. Dither: revelado pixel al aparecer (12-oct: se quitó el círculo pixel bajo el cursor, pedido de Nicolás) ---------- */
  var BAYER = [0, 8, 2, 10, 12, 4, 14, 6, 3, 11, 1, 9, 15, 7, 13, 5];
  var LIGHT = [239, 238, 232], DARK = [13, 13, 13];
  function ready(img, cb) {
    if (img.complete && img.naturalWidth) cb(); else img.addEventListener('load', cb, { once: true });
  }
  function ditherData(img, cols, rows, boxW, boxH) {
    /* Recorte tipo object-fit: cover. Si la imagen no es del mismo origen, getImageData falla y no hay efecto. */
    var c = document.createElement('canvas');
    c.width = cols; c.height = rows;
    var x = c.getContext('2d', { willReadFrequently: true });
    var iw = img.naturalWidth, ih = img.naturalHeight;
    var scale = Math.max(boxW / iw, boxH / ih);
    var sw = boxW / scale, sh = boxH / scale;
    x.drawImage(img, (iw - sw) / 2, (ih - sh) / 2, sw, sh, 0, 0, cols, rows);
    var d = x.getImageData(0, 0, cols, rows).data;
    var bits = new Uint8Array(cols * rows);
    for (var j = 0; j < rows; j++) {
      for (var i = 0; i < cols; i++) {
        var k = (j * cols + i) * 4;
        var l = (0.2126 * d[k] + 0.7152 * d[k + 1] + 0.0722 * d[k + 2]) / 255;
        l = Math.min(1, Math.max(0, (l - 0.5) * 1.35 + 0.5));
        bits[j * cols + i] = l > (BAYER[(j & 3) * 4 + (i & 3)] + 0.5) / 16 ? 1 : 0;
      }
    }
    return bits;
  }
  function Dither(box, getImg) {
    this.box = box; this.getImg = getImg;
    this.cv = document.createElement('canvas');
    this.cv.className = 'dc-dither';
    this.cv.setAttribute('aria-hidden', 'true');
    box.appendChild(this.cv);
    this.ctx = this.cv.getContext('2d');
    this.cache = {};
  }
  Dither.prototype.grid = function () {
    var r = this.box.getBoundingClientRect();
    var dot = Math.max(3, Math.round(r.width / 120));
    return { w: r.width, h: r.height, dot: dot, cols: Math.ceil(r.width / dot), rows: Math.ceil(r.height / dot) };
  };
  Dither.prototype.bits = function (img, g) {
    var key = (img.currentSrc || img.src) + '|' + g.cols + 'x' + g.rows;
    if (!this.cache[key]) {
      try { this.cache[key] = ditherData(img, g.cols, g.rows, g.w, g.h); } catch (e) { this.cache[key] = null; }
    }
    return this.cache[key];
  };
  /* mask(i, j) → 0..1; la celda se pinta si supera su umbral Bayer: el borde también queda en pixel. */
  Dither.prototype.paint = function (img, g, mask) {
    var bits = this.bits(img, g);
    if (!bits) return false;
    if (this.cv.width !== g.cols || this.cv.height !== g.rows) { this.cv.width = g.cols; this.cv.height = g.rows; this.img = null; }
    if (!this.img) this.img = this.ctx.createImageData(g.cols, g.rows);
    var px = this.img.data;
    for (var j = 0; j < g.rows; j++) {
      for (var i = 0; i < g.cols; i++) {
        var n = j * g.cols + i, k = n * 4;
        var on = mask(i, j) > (BAYER[(j & 3) * 4 + (i & 3)] + 0.5) / 16;
        if (on) { var c = bits[n] ? LIGHT : DARK; px[k] = c[0]; px[k + 1] = c[1]; px[k + 2] = c[2]; px[k + 3] = 255; } else { px[k + 3] = 0; }
      }
    }
    this.ctx.putImageData(this.img, 0, 0);
    return true;
  };
  Dither.prototype.clear = function () { this.ctx.clearRect(0, 0, this.cv.width, this.cv.height); };
  Dither.prototype.reveal = function () {
    var self = this, img = this.getImg();
    if (!img) return;
    ready(img, function () {
      var g = self.grid(), t0 = performance.now(), dur = 950;
      if (!self.paint(img, g, function () { return 1; })) return;
      (function step(now) {
        var t = Math.min(1, (now - t0) / dur);
        self.paint(img, g, function (i, j) { return 1 - t * 1.7 + (j / g.rows) * 0.7; });
        if (t < 1) requestAnimationFrame(step); else self.clear();
      })(t0);
    });
  };
  function initDither() {
    var boxes = [];
    document.querySelectorAll('.dc-card__media').forEach(function (m) { if (m.querySelector('img.dc-card__img-1, img')) boxes.push(m); });
    document.querySelectorAll('.dc-pdp__gallery figure').forEach(function (f) { if (f.querySelector('img')) boxes.push(f); });
    boxes.forEach(function (box) {
      box._dcDither = new Dither(box, function () {
        return box.querySelector('img.dc-card__img-1') || box.querySelector('img');
      });
    });
    onEnter(boxes.filter(belowFold), function (box) { box._dcDither && box._dcDither.reveal(); }, '0px 0px -10% 0px');
  }

  /* ---------- 5. Glitch en la tarjeta del próximo drop ---------- */
  function initGlitch() {
    document.querySelectorAll('.dc-feat a.dc-card .dc-card__media--empty').forEach(function (m) {
      var big = m.querySelector('.dc-card__big');
      if (!big) return;
      big.setAttribute('data-text', big.textContent.trim());
      big.classList.add('dc-glitch');
      var n = document.createElement('span');
      n.className = 'dc-noise';
      n.setAttribute('aria-hidden', 'true');
      m.appendChild(n);
    });
  }

  /* ---------- 6. Muro de stickers con física (matter.js se carga solo al acercarse) ---------- */
  function loadScript(src, cb) {
    if (window.Matter) return cb();
    var s = document.createElement('script');
    s.src = src; s.async = true; s.onload = cb;
    document.head.appendChild(s);
  }
  function initStickers() {
    var wall = document.querySelector('[data-dc-stickers] .dc-stk__wall');
    if (!wall || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) {
      if (!en[0].isIntersecting) return;
      io.disconnect();
      loadScript(wall.getAttribute('data-matter'), function () {
        /* Se mide cada sticker con su tipografía ya cargada. */
        var fonts = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
        fonts.then(function () { if (window.Matter) startStickers(wall); });
      });
    }, { rootMargin: '300px 0px' });
    io.observe(wall);
  }
  function startStickers(wall) {
    var M = window.Matter, Engine = M.Engine, Bodies = M.Bodies, Comp = M.Composite, Body = M.Body, Constraint = M.Constraint;
    var engine = Engine.create({ enableSleeping: true });
    engine.gravity.y = 1.05;
    var els = [].slice.call(wall.querySelectorAll('.dc-stk__s'));
    wall.classList.add('is-live');
    var W = wall.clientWidth, H = wall.clientHeight, walls = [];
    function bounds() {
      if (walls.length) Comp.remove(engine.world, walls);
      var t = 400;
      walls = [
        Bodies.rectangle(W / 2, H + t / 2, W + t * 2, t, { isStatic: true, friction: 0.9 }),
        Bodies.rectangle(-t / 2, H / 2 - 600, t, H * 2 + 1200, { isStatic: true }),
        Bodies.rectangle(W + t / 2, H / 2 - 600, t, H * 2 + 1200, { isStatic: true })
      ];
      Comp.add(engine.world, walls);
    }
    bounds();
    var items = els.map(function (el, i) {
      var w = el.offsetWidth, h = el.offsetHeight;
      var round = el.classList.contains('dc-stk__s--circle');
      var opts = { restitution: 0.32, friction: 0.55, frictionAir: 0.012, density: 0.0018 };
      var x = w / 2 + 8 + Math.random() * Math.max(1, W - w - 16);
      var y = -h - 20 - i * 46;
      var square = /dc-stk__s--(line|mono|logo)/.test(el.className);
      var body = round ? Bodies.circle(x, y, w / 2, opts) : Bodies.rectangle(x, y, w, h, Object.assign({ chamfer: { radius: square ? 4 : Math.max(2, h / 2 - 1) } }, opts));
      Body.setAngle(body, (Math.random() - 0.5) * 0.9);
      return { el: el, body: body, w: w, h: h, added: false };
    });
    items.forEach(function (it, i) {
      setTimeout(function () { Comp.add(engine.world, it.body); it.added = true; it.el.classList.add('is-in'); }, 120 + i * 110);
    });
    var running = true, raf = 0;
    function frame() {
      raf = 0;
      if (!running) return;
      Engine.update(engine, 1000 / 60);
      items.forEach(function (it) {
        if (!it.added) return;
        var p = it.body.position;
        it.el.style.transform = 'translate(' + (p.x - it.w / 2).toFixed(1) + 'px,' + (p.y - it.h / 2).toFixed(1) + 'px) rotate(' + it.body.angle.toFixed(4) + 'rad)';
      });
      raf = requestAnimationFrame(frame);
    }
    raf = requestAnimationFrame(frame);
    new IntersectionObserver(function (en) {
      running = en[0].isIntersecting;
      if (running && !raf) raf = requestAnimationFrame(frame);
    }).observe(wall);

    /* Arrastrar y lanzar: solo sobre los stickers; el resto del muro deja hacer scroll en el celular. */
    var drag = null;
    function local(e) { var r = wall.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; }
    wall.addEventListener('pointerdown', function (e) {
      var el = e.target.closest('.dc-stk__s');
      var it = el && items.filter(function (x) { return x.el === el; })[0];
      if (!it || !it.added) return;
      e.preventDefault();
      try { el.setPointerCapture(e.pointerId); } catch (err) {}
      var pt = local(e);
      Body.set(it.body, 'isSleeping', false);
      drag = { it: it, id: e.pointerId, c: Constraint.create({ pointA: pt, bodyB: it.body, pointB: { x: pt.x - it.body.position.x, y: pt.y - it.body.position.y }, stiffness: 0.18, damping: 0.08, length: 0 }) };
      Comp.add(engine.world, drag.c);
      el.classList.add('is-drag');
    });
    wall.addEventListener('pointermove', function (e) { if (drag && e.pointerId === drag.id) drag.c.pointA = local(e); });
    function drop(e) {
      if (!drag || (e && e.pointerId !== drag.id)) return;
      Comp.remove(engine.world, drag.c);
      drag.it.el.classList.remove('is-drag');
      drag = null;
    }
    wall.addEventListener('pointerup', drop);
    wall.addEventListener('pointercancel', drop);
    wall.addEventListener('lostpointercapture', drop);

    var rt = 0;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        W = wall.clientWidth; H = wall.clientHeight; bounds();
        items.forEach(function (it) {
          var p = it.body.position;
          if (p.x > W - 10 || p.y > H) { Body.setPosition(it.body, { x: Math.min(p.x, W - it.w / 2), y: Math.min(p.y, H - it.h) }); Body.set(it.body, 'isSleeping', false); }
        });
      }, 200);
    });
  }

  /* ---------- 7. API para páginas que se pintan con JS ([the_ritual], 12-oct-2026) ----------
     dc-ritual.js llama a estos efectos al abrir cada pantalla. roll() es el odómetro sin MutationObserver:
     el número ya está escrito en el elemento y rueda desde el texto anterior. */
  function roll(el, prev) {
    var text = el.textContent;
    if (!text || text === prev) return;
    var STRIP = '<span>0</span><span>1</span><span>2</span><span>3</span><span>4</span><span>5</span><span>6</span><span>7</span><span>8</span><span>9</span>';
    var chars = text.split(''), targets = [], html = '<span class="dc-odo" aria-hidden="true">';
    chars.forEach(function (c, i) {
      if (/\d/.test(c)) {
        var old = prev.charAt(prev.length - chars.length + i), start = /\d/.test(old) ? +old : 0;
        html += '<span class="dc-odo__d"><span class="dc-odo__s" style="transition:none;transform:translateY(' + (-start * 10) + '%)">' + STRIP + '</span></span>';
        targets.push(+c);
      } else {
        html += '<span>' + c.replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</span>';
      }
    });
    el.innerHTML = html + '</span><span class="visually-hidden">' + text.replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</span>';
    var strips = el.querySelectorAll('.dc-odo__s');
    el.offsetWidth;
    [].forEach.call(strips, function (s, k) {
      s.style.transition = 'transform ' + (0.55 + k * 0.08) + 's ' + EASE;
      s.style.transform = 'translateY(' + (-targets[k] * 10) + '%)';
    });
  }
  window.dcFx = {
    decode: decode,
    roll: roll,
    dither: function (box) {
      if (!box._dcDither) box._dcDither = new Dither(box, function () { return box.querySelector('img'); });
      box._dcDither.reveal();
    },
    noise: function (el) {
      if (el.querySelector('.dc-noise')) return;
      var n = document.createElement('span');
      n.className = 'dc-noise';
      n.setAttribute('aria-hidden', 'true');
      el.appendChild(n);
    }
  };
  try { document.dispatchEvent(new CustomEvent('dc-fx:ready')); } catch (e) {}

  function init() {
    initDecode();
    initLit();
    initOdometer();
    initDither();
    initGlitch();
    initStickers();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
